import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const trustItems = ['Pago único', 'Acceso inmediato', 'Soporte ante inconvenientes de acceso', 'Garantía de 7 días'];
export function Guarantee() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-68" data-mp="222wjq90ra2o5">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-aura/25 bg-card p-8 text-center sm:p-12" data-id="element-69" data-mp="1x420x72sge41">
        <span className="flex h-24 w-24 flex-col items-center justify-center rounded-full border-2 border-gold/60 bg-aura text-white" aria-hidden="true" data-id="element-70" data-mp="1edu2v3dy4dup">
          <span className="font-serif-display text-2xl font-bold leading-none" data-id="element-71" data-mp="qmyd0bt1vsq3">7</span>
          <span className="mt-1 text-[9px] font-bold leading-tight tracking-[0.12em]" data-id="element-72" data-mp="lo51uq18kdt3">
            DÍAS DE
            <br data-id="element-73" data-mp="oyqfacyku3l9" />
            GARANTÍA
          </span>
        </span>

        <h2 className="mt-6 font-serif-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-74" data-mp="ty2xgkei6mhi">
          Probá Aura Viva 2026 durante 7 días.
        </h2>

        <p className="mt-4 text-sm leading-relaxed text-plum/80 sm:text-base" data-id="element-75" data-mp="yq4h4re03fhk">
          Recorré el material con tranquilidad. Si dentro de los 7 días considerás que no es para
          vos, podés solicitar la garantía según las condiciones informadas.
        </p>

        <ul className="mt-7 grid w-full gap-3 text-left sm:grid-cols-2" data-id="element-76" data-mp="b0ryz20p3x34">
          {trustItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-77" data-mp="f0ajvxsio85y">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-78" data-mp="k06qm4slmdp7">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-79" data-mp="1qhab0q34ogye" />
              </span>
              <span className="text-sm leading-relaxed text-plum/80" data-id="element-80" data-mp="1vesnurk9ngbo">{item}</span>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}